module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedBold.0475d5b.woff";